import React from "react";
import NoItems from "../Common/NoItems";
import { useDispatch } from "react-redux";
import {
  toogleConversation,
  toggleSidebar,
} from "../../Redux/reducers/responsiveHandle";
import { Button } from "reactstrap";
import { BsChatDotsFill } from "react-icons/bs";

export default function NoConversation() {
  const dispatch = useDispatch();
  return (
    <>
      <div className=" d-flex flex-column justify-content-center">
        <NoItems
          title="No conversations!"
          subText={`Please open a conversation from left panel to start messaging. `}
          imageHeight={120}
          imageWidth={120}
          shadow={false}
        />
        <div className="open-sidebar">
          <Button
            color="primary"
            onClick={() => {
              dispatch(toogleConversation());
              dispatch(toggleSidebar());
            }}
          >
            {`Open Conversations `}
            <BsChatDotsFill />
          </Button>{" "}
        </div>
      </div>

    </>
  );
}
